// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"_f"};